import React,{useState,useEffect} from 'react';
import {useParams} from 'react-router-dom'
import {useSelector,useDispatch} from 'react-redux'
// comps
import ProfileInfoPart from '../comps/profileInfoPart'
import UserOptions from '../comps/useroptions'
import FriendPart from '../comps/friendPart'
import MainBody from '../comps/mainBody'
import Headerphoto from '../comps/headerphoto'
import {Helmet} from "react-helmet";
import StoryViewer from '../comps/storyViewer'
import { hasStory } from '../utils/story'
import * as likeActions from '../data/comment_data'
import * as authAction from '../store/authAction'
import * as actions from '../data/follow_data'
import {useNavigate} from 'react-router-dom';

const Visted = props => {
  const {id} = useParams();
  const dispatch = useDispatch();
const navigate = useNavigate();

  useEffect(()=>{
    const loadProfile = async () => {
      const userData = localStorage.getItem('userdata');
      try {
        if(userData){
          const {id: userId, pid} = JSON.parse(userData);
          await dispatch(authAction.auth(userId,pid));
          await dispatch(actions.get_follow());
        }
        await dispatch(likeActions.get_visted_posts(id));
        await dispatch(likeActions.get_user_info(id));
      } finally {
        setIsLoading(false);
      }
    }
    loadProfile();
  },[dispatch, id])

const userlistr = useSelector(state => state.authReduse);
  const [isStory,setStory] = useState(false);
  const list = useSelector(state => state.PostReducer.vistedPost.filter(post => post.userid === id)) ;
const userlist = useSelector(state => state.followReduse.userFollow);
  const[isType,setType] = useState('i');
  const [isLoading, setIsLoading] = useState(true);
  const translations = useSelector(state => state.lang_reduse.lang);
  const emptyTitle = isType === 'h'
    ? translations.thereisnohistory
    : isType === 'i'
      ? translations.thereisnophotos
      : isType === 's'
        ? translations.thereisnoshorts
        : translations.thereisnovideos;

  return(
  <section className="homePage visitedHomepage">
    <Helmet>
      <meta name="theme-color" content="#E8E9EB" />
    <title>{userlist.email}</title>
  <meta name="description" content='pinweelo website user'/>
<meta name='keywords' content={`pinweelo website , ${userlist.email?userlist.email:[]},vist`}/>
 <link rel="canonical" href={`https://pinweelo.com/@${id}`} />
    </Helmet>
    <FriendPart />
<Headerphoto name={userlistr.name} img={userlistr.big_img}/>
    <StoryViewer
      open={isStory}
      onClose={() => setStory(false)}
      media={userlist?.story}
      name={userlist?.email || userlist?.name}
      photo={userlist?.photo}
    />
<div className='ProfileInfoWithOptions'>
  <ProfileInfoPart
    postsCount={list?.length}
    navigatee={()=>navigate(`../chat/${userlist.id}`)}
    vist={true}
    story={() => { if (hasStory(userlist?.story)) setStory(true) }}
    userlist={userlist?userlist:[]}
  />
</div>
  <UserOptions setType={setType} isType={isType} />
<MainBody embedded isload={isLoading} list={list} Visted={true} type={isType} emptyTitle={emptyTitle} />

  </section>
  )
}
export default Visted;
